/* eslint-disable import/prefer-default-export */
import instance from 'utils/axios/instance.axios';
import { PROPOSAL_PROGRAMS } from './_constant';

export const getAll = () => instance.get(PROPOSAL_PROGRAMS.GET_ALL);
